import { ApplicationListScreen } from "@/features/staff/applications";

export default ApplicationListScreen;
